import { css } from '@emotion/react'
import { HFlow, Icon, Icons, Text, Tooltip, VFlow } from 'bold-ui'
import { gray } from 'bold-ui/lib/styles/colors'
import { GrupoRisco, Risco } from 'graphql/types.generated'

import { RastreamentosEstratificacaoTag } from './RastreamentosEstratificacaoTag'

interface RastreamentosListCardProps {
  riscos: ReadonlyArray<Risco>
}

const GRUPO_RISCO_MAP: Record<GrupoRisco, { icon: Icons; titulo: string }> = {
  [GrupoRisco.CARDIOVASCULAR]: { icon: 'heartRateFilled', titulo: 'Risco Cardiovascular' },
  [GrupoRisco.DENGUE]: { icon: 'infoCircleFilled', titulo: 'Risco de Dengue' },
  [GrupoRisco.PRE_ECLAMPSIA]: { icon: 'infoCircleFilled', titulo: 'Risco de Pré-eclâmpsia' },
}

export function RastreamentosListCard(props: Readonly<RastreamentosListCardProps>) {
  const { riscos } = props

  return (
    <VFlow vSpacing={0.5}>
      {riscos.map((risco, index) => {
        const { estratificacao, origem, descricaoOrigem, grupo } = risco
        const { icon, titulo } = grupo ? GRUPO_RISCO_MAP[grupo] : {}

        return (
          <HFlow hSpacing={0.5} key={index}>
            <Icon icon={icon} color={gray.c40} />
            <VFlow vSpacing={0.25}>
              <HFlow hSpacing={0.5} alignItems='center'>
                <Text fontWeight='bold'>{titulo}</Text>
              </HFlow>

              {estratificacao && <RastreamentosEstratificacaoTag estratificacao={estratificacao} />}

              <HFlow hSpacing={0.5} alignItems='center'>
                {origem && (
                  <Text fontStyle='italic' style={styles.identificadoPorText}>
                    {origem}
                  </Text>
                )}
                {descricaoOrigem && (
                  <Tooltip text={descricaoOrigem}>
                    <Icon icon='infoCircleFilled' size={1} />
                  </Tooltip>
                )}
              </HFlow>
            </VFlow>
          </HFlow>
        )
      })}
    </VFlow>
  )
}

const styles = {
  identificadoPorText: css`
    color: ${gray.c40};
  `,
}
